import { FC } from 'react';

import { useLingui } from '@lingui/react';
import MuiTextField from '@mui/material/TextField';

import { Autocomplete } from 'src/components/formik-material-ui/Autocomplete';

interface UserNode {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    isActive: boolean;
}

export const CompanyUserSelect: FC = (props: any) => {
    const { required, users } = props;
    const { i18n } = useLingui();

    return (
        <Autocomplete
            {...props}
            isOptionEqualToValue={(option: UserNode, value?: UserNode) => option?.id === value?.id}
            getOptionLabel={(option: UserNode): string =>
                option.firstName || option.lastName
                    ? `${option.firstName} ${option.lastName} (${option.email}) ${
                          option.isActive ? '' : i18n._('(Inactive)')
                      }`
                    : `${option.email} ${option.isActive ? '' : i18n._('(Inactive)')}`
            }
            options={users}
            renderInput={(params: any): JSX.Element => (
                <MuiTextField
                    fullWidth
                    variant="outlined"
                    name={props.field.name}
                    {...params}
                    error={!!props.form.errors[props.field.name]}
                    helperText={
                        props.form.touched[props.field.name] && props.form.errors[props.field.name]
                    }
                    label={props.label || 'User'}
                    required={!!required}
                />
            )}
        />
    );
};
